import {
  FormPage,
  FormPageInputData,
  FormPageInputItem,
  FormPageProperty,
  InputData,
  MultipleSelectionProperty,
  SingleSelectionProperty,
} from 'shared';

type GetMappedPropertyArrayReturnType = {
  property: FormPageProperty;
  inputItem?: FormPageInputItem;
}[];

export const getMappedProperties = (
  formPage: FormPage,
  inputData: InputData
): GetMappedPropertyArrayReturnType => {
  const { uiOrder, properties } = formPage;
  if (!uiOrder || !properties) {
    return [];
  }
  const inputItems = Object.values(inputData).reduce(
    (acc, formPageInputData) => {
      return {
        ...acc,
        ...formPageInputData,
      };
    },
    {} as FormPageInputData
  );

  return uiOrder.map((propertyId) => {
    return {
      property: properties[propertyId] as FormPageProperty,
      inputItem: inputItems[propertyId],
    };
  });
};

type GetSelectionLabelAndIndexPayload = {
  value: number | undefined;
  candidates:
    | SingleSelectionProperty['candidates']
    | MultipleSelectionProperty['candidates'];
};
export const getSelectionLabelAndIndex = ({
  value,
  candidates,
}: GetSelectionLabelAndIndexPayload): {
  label: string;
  index?: number;
} => {
  let label = '';
  let index: number | undefined = undefined;
  const candidatesExcludeUnselected = candidates.filter(
    (candidate) => candidate.value != null
  );
  candidatesExcludeUnselected.forEach((candidate, i) => {
    const inputItemValue = value ?? null;
    if (candidate.value === inputItemValue) {
      label = candidate.label;
      index = i + 1;
    }
  });
  return { label, index };
};
